import { z } from 'zod';

export const schoolYearSchema = z.object({
  anoEscolarId: z.string(),
  anoEscolarNome: z.string(),
});

export type SchoolYear = z.infer<typeof schoolYearSchema>;

export const schoolYearsResponseSchema = z.array(schoolYearSchema);

export type SchoolYearsResponse = z.infer<typeof schoolYearsResponseSchema>;
